import { create } from 'zustand';

import type { Config } from '@/models';

function num(val: string | undefined, fallback: number): number {
  const n = Number(val);
  return Number.isFinite(n) ? n : fallback;
}

export const useConfig = create<Config>(() => ({
  // API
  apiBaseUrl: (import.meta.env.VITE_API_BASE as string) ?? '',
  socketBaseUrl: (import.meta.env.VITE_SOCKET_BASE as string) ?? '',
  apiTimeout: num(import.meta.env.VITE_API_TIMEOUT as string, 30000),
  // WS
  // (socketBaseUrl above)
  // SIP
  sipWsUrl: (import.meta.env.VITE_SIP_WS_URL as string) ?? '',
  sipUri: (import.meta.env.VITE_SIP_URI as string) ?? '',
  // MAP
  googleMapsApiKey: (import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string) ?? '',
  // Fire / emergency
  firePhoneNumber: (import.meta.env.VITE_FIRE_PHONE_NUMBER as string) ?? '999',
  // Operator status sync (ms)
  operatorStatusUpdateSyncInterval: num(
    import.meta.env.VITE_OPERATOR_STATUS_UPDATE_SYNC_INTERVAL as string,
    3000,
  ),
  // Admin console iframe base URL
  tintinAdminConsoleUrl:
    (import.meta.env.VITE_TINTIN_ADMIN_CONSOLE_URL as string) ?? '',
  // Dev mode
  dev: import.meta.env.DEV,
}));
